export function isNotificationOfType(notification, type) {
    return notification.type === type;
}
export const typeToColor = {
    channel: 'purple',
};
